import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Play, Clock } from "lucide-react";
import { API } from "@/lib/api";

const VIDEOS = [
  { key: "sales", title: "KlenaPro in 40 seconds", length: "0:38", blurb: "The live Timeline, instant roster updates, translated messaging and payroll-ready timesheets — the whole pitch, fast." },
  { key: "guide", title: "The full product guide", length: "7:49", blurb: "A page-by-page walkthrough of the manager and cleaner apps, and how each one replaces paper lists, whiteboards and spreadsheets." },
];

function VideoCard({ v }) {
  const [playing, setPlaying] = useState(false);
  const src = `${API}/public/videos/${v.key}`;
  return (
    <div className="group overflow-hidden rounded-xl border border-border bg-card shadow-sm" data-testid={`video-card-${v.key}`}>
      <div className="relative aspect-video bg-black">
        {playing ? (
          <video src={src} poster={`${src}?poster=1`} controls autoPlay playsInline className="h-full w-full" data-testid={`video-player-${v.key}`} />
        ) : (
          <button type="button" onClick={() => setPlaying(true)} className="relative block h-full w-full" data-testid={`video-play-${v.key}`} aria-label={`Play ${v.title}`}>
            <img src={`${src}?poster=1`} alt="" className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-[1.02]" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="flex h-16 w-16 items-center justify-center rounded-full bg-white/95 text-primary shadow-lg transition-transform group-hover:scale-110">
                <Play className="ml-1 h-7 w-7" fill="currentColor" />
              </span>
            </span>
            <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-black/70 px-2.5 py-1 text-xs font-medium text-white"><Clock className="h-3 w-3" /> {v.length}</span>
          </button>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold md:text-lg">{v.title}</h3>
        <p className="mt-1.5 text-sm text-muted-foreground">{v.blurb}</p>
      </div>
    </div>
  );
}

export function VideoShowcase() {
  return (
    <section id="videos" className="border-y border-border bg-secondary/40" data-testid="video-showcase">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">See it working</p>
            <h2 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Watch a real housekeeping day run on KlenaPro</h2>
            <p className="mt-3 text-muted-foreground">Screens from a live property (staff names changed). Pick the quick tour or the full guide.</p>
          </div>
          <Link to="/signup" data-testid="videos-trial-btn">
            <Button size="lg" className="k-press gap-2">Start free trial <ArrowRight className="h-4 w-4" /></Button>
          </Link>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {VIDEOS.map((v) => <VideoCard key={v.key} v={v} />)}
        </div>
      </div>
    </section>
  );
}
